$(document).ready(function() {
    /*yt backgrounds */
    let $video_wrap = $(".video_wrap");
    $video_wrap.removeClass("d-none");
    $video_wrap.hide();
    let $feature_video_player = $video_wrap.find("#player");

    if($feature_video_player.length){
        let feature_video_src_id = $feature_video_player.data('feature-video-src-id');
        let feature_video_start = $feature_video_player.data('feature-video-start');
        let feature_video_end = $feature_video_player.data('feature-video-end');

        feature_video_start = feature_video_start && !isNaN(feature_video_start) ? feature_video_start : null;
        feature_video_end = feature_video_end && !isNaN(feature_video_end) ? feature_video_end : null;if (feature_video_src_id && $(window).width() >= 640)
        {
            // Loads the YouTube IFrame API JavaScript code.
            let tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            // Inserts YouTube JS code into the page.
            let firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            let player;
            let current_site = null

            let large_video = $(".video_wrap:first");
            if (large_video)
            {
                current_site = large_video.data("currentsite");
            }


            // onYouTubeIframeAPIReady() is called when the IFrame API is ready to go.
            window.onYouTubeIframeAPIReady = function ()
            {

                let vars = {
                    height: '360',
                    width: '640',
                    origin: current_site,
                    videoId: feature_video_src_id,
                    playerVars: {
                        autoplay: 1,
                        controls: 0,
                        showinfo: 0,
                        rel: 0,
                        enablejsapi:1,
                        origin: current_site,
                        wmode : 'transparent'
                    },
                    events : {
                        onReady : pkOnPlayerReady,
                        onStateChange : pkOnPlayerStateChange
                    }
                }

                if(feature_video_start != null){
                    vars.start = feature_video_start;
                    vars.playerVars.start = feature_video_start;
                }
                if(feature_video_end != null){
                    vars.playerVars.end = feature_video_end;
                }

                player = new YT.Player('player',vars);
            }

            function pkOnPlayerStateChange(e) {
                let frm = $(e.target.getIframe());
                if (e.data === YT.PlayerState.ENDED) {
                    if ('player' === frm.attr('id')) {
                        player.playVideo();
                    }
                }
                if (e.data === YT.PlayerState.BUFFERING) {
                    if ('player' === frm.attr('id')) {
                        e.target.setPlaybackQuality('hd720');
                    }
                }
            }
            function pkOnPlayerReady(e) {
                player.mute();
                e.target.setPlaybackQuality('hd720');
            }

            //Load a youtube pixel
            let pkEnableYoutube = function() {
                let deferred = jQuery.Deferred();
                let img = new Image();
                img.onload = function() { return deferred.resolve(); };
                img.onerror = function() { return deferred.reject(); };
                img.src = "https://s.ytimg.com/yts/img/pixel-vfl3z5WfW.gif?"+ new Date().getTime();
                return deferred.promise();
            };

            //When the video starts to load, set a timer for the video wrap to fade in
            jQuery(function($){

                $.when(pkEnableYoutube()).done(function(){
                    setTimeout(function() {
                        $('.video_wrap').fadeIn();
                    }, 2000);
                });
            });
        }

        //use .one to ensure this only happens once
        $("#feature-video-small-play").one(function()
        {
            let $feature_video_small = $("#feature-video-small")
            let symbol = $feature_video_small[0].src.indexOf("?") > -1 ? "&" : "?";
            $feature_video_small[0].src += symbol + "autoplay=1";
        });
    }

});